/* unplugin-vue-components disabled */import { render } from "./rightbar-content.vue?vue&type=template&id=35b073dd&scoped=true"
import script from "./rightbar-content.vue?vue&type=script&lang=js"
export * from "./rightbar-content.vue?vue&type=script&lang=js"

import "./rightbar-content.vue?vue&type=style&index=0&id=35b073dd&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b073dd"],['__file',"src/pages/pulse/rightbar-content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35b073dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35b073dd', __exports__)) {
    api.reload('35b073dd', __exports__)
  }
  
  module.hot.accept("./rightbar-content.vue?vue&type=template&id=35b073dd&scoped=true", () => {
    api.rerender('35b073dd', render)
  })

}


export default __exports__